import { create } from 'zustand';
import type { OrdersType } from '@/types/order';



const MAX_ORDERS = 5000;

type OrdersState = {
    orders: OrdersType[];

    setOrders: (orders: OrdersType[]) => void;
    appendOrders: (orders: OrdersType[]) => void;
    upsertOrder: (order: Partial<OrdersType>) => void;
    removeOrder: (id: number) => void;
    clearOrders: () => void;
};

export const useOrdersStore = create<OrdersState>()((set, get) => ({

    orders: [],

    setOrders: (orders) =>
        set({ orders: orders.slice(0, MAX_ORDERS) }),

    appendOrders: (incoming) => {
        const existing = get().orders;
        const existingIds = new Set(existing.map(o => o.id));
        const newOnes = incoming.filter(o => !existingIds.has(o.id));

        // append then cap — oldest (tail) get dropped
        set({ orders: [...existing, ...newOnes].slice(0, MAX_ORDERS) });
    },

    upsertOrder: (incoming) => {
        if (!incoming?.id) return;

        const orders = get().orders;
        const idx = orders.findIndex(o => o.id === incoming.id);

        if (idx === -1) {
            // new order — prepend to top, pop oldest if over limit
            const next = [incoming as OrdersType, ...orders];
            if (next.length > MAX_ORDERS) next.pop(); // remove last (oldest)
            set({ orders: next });
        } else {
            // existing — merge in place, no position change, no cap needed
            const updated = [...orders];
            updated[idx] = { ...updated[idx], ...incoming };
            set({ orders: updated });
        }
    },

    removeOrder: (id) =>
        set({ orders: get().orders.filter(o => o.id !== id) }),

    clearOrders: () => set({ orders: [] }),

}));